/**
 *
 * @Info
 * As a rule of thumb we name the exported getter
 * in CamelCaseCaps and the actual getter value in camelCase.
 */

// AUTH STORE GETTERS
export const GetUserData = 'getUserData';
export const GetOrganizationId = 'getOrganizationId';
export const GetOrganizationName = 'getOrganizationName';
export const GetActiveOrganization = 'getActiveOrganization';
export const GetActiveOrganizationRole = 'getActiveOrganizationRole';
export const GetLastOrganizationId = 'getLastOrganizationId';
export const GetOrganizations = 'getOrganizations';
export const GetOrganizationById = 'getOrganizationById';
export const HasUnlimitedAccess = 'hasUnlimitedAccess';

export const GetMainSubscription = 'getMainSubscription';

// NOTIFICATIONS
export const GetNotifications = 'getNotifications';
export const GetToastNotifications = 'getToastNotifications';
export const GetPlatformNotifications = 'getPlatformNotifications';

// CONVERSATIONS
export const GetCurrentConversation = 'getCurrentConversation';
export const GetCurrentConversationName = 'getCurrentConversationName';
export const GetUserConversations = 'getUserConversations';
export const GetConversationScope = 'getConversationScope';
export const GetIsTyping = 'getIsTyping';
export const GetConversationFilters = 'getConversationFilters';
export const GetIsNewConversation = 'getIsNewConversation';
export const GetAuthoringStarted = 'getAuthoringStarted';
export const GetExpandedFilters = 'getExpandedFilters';
export const GetTacticContextFilters = 'getTacticContextFilters';
export const GetProductAndCountryFilter = 'getProductAndCountryFilter';
export const GetSelectedValues = 'getSelectedValues ';
export const GetIsResearchModeOn = 'getIsResearchModeOn ';

// REFERENCE DIALOG
export const GetSelectedReference = 'getSelectedReference';
export const GetShowDocumentPopup = 'getShowDocumentPopup';

// MODALS
export const GetShowTranslationModal = 'getShowTranslationModal';
export const GetSelectedExternalIdForTranslate = 'getSelectedExternalIdTranslate';
export const GetReferenceNameForTranslate = 'getReferenceNameForTranslate';
export const GetShowPreviewDocument = 'getShowPreviewDocument';
export const GetShowPreviewAuthorDocument = 'getShowPreviewAuthorDocument';
export const GetCurrentDocumentsDialog = 'getCurrentDocumentsDialog';
export const GetCreateCollectionPopup = 'getCreateCollectionPopup';
export const GetAddToCollectionPopup = 'getAddToCollectionPopup';
export const GetGlossaryModal = 'getGlossaryModal';
export const GetWarningPopup = 'getWarningPopup';
export const GetShowFilters = 'getShowFilters';
export const GetShowFiles = 'GetShowFiles';
export const GetSharedLinkCollection = 'getSharedLinkCollection';

// LANGUAGE
export const GetCurrentLanguageCode = 'getCurrentLanguageCode';

// COLLECTIONS
export const GetCollectionCount = 'getCollectionCount';
export const GetCollection = 'getCollection';
export const IsInCollection = 'isInCollection';
export const GetUserCollections = 'getUserCollections';

// DOCUMENTS
export const GetAllTemplates = 'getAllTemplates';
export const GetCurrentTemplate = 'getCurrentTemplate';
export const GetCurrentDesignSystemDocumentElements = 'getCurrentDesignSystemDocumentElements';
export const GetSelectedObjectDocumentEditor = 'getSelectedObjectDocumentEditor';
export const GetIframeView = 'getIframeView';
export const GetEditorContent = 'getEditorContent';
export const GetAvailableLayouts = 'getAvailableLayouts';
export const GetCurrentLayout = 'getCurrentLayout';
export const GetAuthoredDocuments = 'getAuthoredDocuments';
export const GetSelectedAuthoredDocument = 'getSelectedAuthoredDocument';
export const GetUndoStack = 'getUndoStack';
export const GetRedoStack = 'getRedoStack';
export const GetLayoutsListOpened = 'getLayoutsListOpened';
export const GetMediaPanelOpened = 'getMediaPanelOpened';
export const GetReferencesListOpened = 'getReferencesListOpened';

// FilterForm
export const GetFilters = 'getFilters';
export const GetSearchQuery = 'getSearchQuery';
export const GetTotalMediaImages = 'getTotalMediaImages';
export const GetDsConfig = 'getDsConfig';
export const GetEmailTokens = 'getEmailTokens';
export const IsDownloadInProgress = 'isDownloadInProgress';

// Footnotes
export const GetFootnotes = 'getFootnotes';
export const GetDisplayReferencesOnDocumentLevel = 'getDisplayReferencesOnDocumentLevel';

// Quick prompts
export const GetCurrentFields = 'getCurrentFields';
export const GetCurrentPromptCard = 'getCurrentPromptCard';
export const GetDisplayPromptsInNewTab = 'getDisplayPromptsInNewTab';
export const GetPrompts = 'getPrompts';
export const GetCategories = 'getCategories';
export const GetSelectedCategories = 'getSelectedCategories';
